import React, { useEffect } from 'react';
import { useTheme } from '../../theming/default_theme';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setMenuSelected } from './MenuSlice';
import { useNavigate } from 'react-router-dom';

const Menu: React.FC = () => {
    const theme = useTheme();
    const dispatch = useAppDispatch();
    const menuSelected = useAppSelector((state) => state.menu.menuSelected);
    const navigate = useNavigate();

    useEffect(() => {
        const storedMenu = sessionStorage.getItem('menuSelected');
        if (storedMenu) {
            dispatch(setMenuSelected(storedMenu));
        }
    }, [dispatch]);

    const handleMenuSelected = (menu: string) => {
        dispatch(setMenuSelected(menu));
        sessionStorage.setItem('menuSelected', menu);

        switch (menu) {
            case 'Hospitals':
                console.log('Hospitals menu clicked');
                break;
            case 'Referrals':
                console.log('Referrals menu clicked');
                break;
            case 'Vision Ambassadors':
                console.log('Vision Ambassadors menu clicked');
                break;
            case 'Spectacle Requests':
                console.log('Spectacle Requests menu clicked');
                break;
            default:
                break;
        }
        navigate('/LandingPage');
    };

    return (
        <div className={`flex flex-col justify-start h-screen w-[240px] gap-y-[10] border-r-${theme.borders.width} border-black`} style={{ backgroundColor: "#FFFFFF" }}>
            <div className={`flex  flex-row justify-center items-center  w-[238px]  h-[80px] bg-[#FFFFFF] border-r-${theme.borders.color} border-black`}>
                <img src="/nayonika.png" alt="Landing Page" style={{ width: '102px', height: '55px', top:'16px',left:"69px"}} /> 
            </div>
            <div className={`flex flex-col justify-start h-full w-[240px]  mt-2 bg-[${theme.colors.primary}] border border-2`} style={{ backgroundColor: theme.colors.primary }}>
                <div className={`flex flex-row justify-left items-center pt-2 pb-2 pl-2 pr-2 ml-[10px] mt-10 mr-5 gap-x-[10px] cursor-pointer text-${theme.colors.menutext} ${menuSelected === 'Hospitals' ? 'bg-[#482E15] border border-[#DC9653]' : 'bg-[#926B46]'} rounded-xl`} onClick={()=> handleMenuSelected('Hospitals')}>
                    <img src="/hospital.png" alt="Hospital icon" style={{ width: '24px', height: '24px'}} />
                    <h2 className="flex" style={{fontFamily:theme.typography.fontFamily,fontWeight:theme.typography.fontWeightMedium,fontSize:theme.typography.h2.fontSize,color:theme.colors.menutext,}}>Hospitals</h2>
                </div>
                <div className={`flex flex-row justify-left items-center pt-2 pb-2 pl-2 pr-2 ml-[10px] mt-8 mr-5 gap-x-[10px] cursor-pointer text-${theme.colors.menutext} ${menuSelected === 'Referrals' ? 'bg-[#482E15] border border-[#DC9653]' : 'bg-[#926B46]'} rounded-xl`} onClick={()=> handleMenuSelected('Referrals')}>
                    <img src="/referrals.png" alt="Referrals icon" style={{ width: '24px', height: '24px', top:'16px',left:"69px"}} />
                    <h2 className="flex" style={{fontFamily:theme.typography.fontFamily,fontWeight:theme.typography.fontWeightMedium,fontSize:theme.typography.h2.fontSize,color:theme.colors.menutext,}}>Referrals</h2>
                </div>
                <div className={`flex flex-row justify-left items-center pt-2 pb-2 pl-2 pr-2 ml-[10px] mt-8 mr-5 gap-x-[10px] cursor-pointer text-${theme.colors.menutext} ${menuSelected === 'Vision Ambassadors' ? 'bg-[#482E15] border border-[#DC9653]' : 'bg-[#926B46]'} rounded-xl`} onClick={()=> handleMenuSelected('Vision Ambassadors')}>
                    <img src="/visionambassador.png" alt="Vision Ambassador icon" style={{ width: '24px', height: '24px', top:'16px',left:"69px"}} />
                    <h2 className="flex" style={{fontFamily:theme.typography.fontFamily,fontWeight:theme.typography.fontWeightMedium,fontSize:theme.typography.h2.fontSize,color:theme.colors.menutext,}}>Vision Ambassadors</h2>
                </div>
                <div className={`flex flex-row justify-left items-center pt-2 pb-2 pl-2 pr-2 ml-[10px] mt-8 mr-5 gap-x-[10px] cursor-pointer text-${theme.colors.menutext} ${menuSelected === 'Spectacle Requests' ? 'bg-[#482E15] border border-[#DC9653]' : 'bg-[#926B46]'} rounded-xl`} onClick={()=>  handleMenuSelected('Spectacle Requests')}>
                    <img src="/spectaclerequests.png" alt="Spectacle Requests icon" style={{ width: '24px', height: '24px', top:'16px',left:"69px"}} />
                    <h2 className="flex" style={{fontFamily:theme.typography.fontFamily,fontWeight:theme.typography.fontWeightMedium,fontSize:theme.typography.h2.fontSize,color:theme.colors.menutext,}}>Spectacle Requests</h2>
                </div>
            </div>
        </div>
    );
}     
export default Menu;